import { HTTPConnector } from "appworks/server/connectors/http-connector";
import { Contract } from "appworks/utils/contracts/contract";
import { CommonUIErrors } from "gamevy/components/common-ui-alert-component";
import { gamevyModel } from "gamevy/gamevy-model";

export class GamevyHTTPConnector extends HTTPConnector {

    private recoveryForce: any;

    constructor() {
        HTTPConnector.SPIN_TIMEOUT = 5000;
        super();
    }

    // Crude recovery forcing
    public sendRequest(request: any): Contract<{}> {
        if (this.recoveryForce && request.url === gamevyModel.getOngoingURL()) {
            return new Contract<{}>((resolve) => {
                this.processResponse({ data: this.recoveryForce } as any, resolve);
            });
        }

        return super.sendRequest(request);
    }

    protected processError(error: any, resolve: (value?: any) => void) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.error.code) {
            const data = { code: error.response.data.error.code, data: error.response.data.error };
            const nonFatal: boolean = gamevyModel.useGcm || data.code === CommonUIErrors.SpecificNTError;
            const fatal = !nonFatal;
            this.errorSignal.dispatch(data, fatal);
            if (!fatal) {
                resolve();
            }
        } else if (error.message === "Network Error" ||
            error.message.indexOf("Request failed") > -1 ||
            (error.message.indexOf("timeout") > -1 && error.message.indexOf("exceeded") > -1)) {
            this.errorSignal.dispatch("err.con", true);
        } else {
            throw error;
        }
    }
}

export const gamevyHTTPConnector = new GamevyHTTPConnector();
